const paymentTypes = {
  FETCH_PAYMENT_INTENT: "FETCH_PAYMENT_INTENT",
  FETCH_PAYMENT_INTENT_ERROR: "FETCH_PAYMENT_INTENT_ERROR",
  SET_PAYMENT_SUCCESS: "SET_PAYMENT_SUCCESS",
  SET_PAYMENT_METHODS: "SET_PAYMENT_METHODS",
  FETCH_SETUP_INTENT: "FETCH_SETUP_INTENT",
};

export default paymentTypes;
